// @ts-strict-ignore
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { SavedSearchUnsaved } from 'api/currentUser';
import { Dispatch } from 'store/main';
import {
  saveListing as saveListingAction,
  saveSearch as saveSearchAction,
} from 'store/main/ducks/currentUser';
import { subscribeToSubsite as subscribeToSubsiteAction } from 'store/main/ducks/subscribedSubsites';
import { getFirstParam, getRelativeURL, isExternalURL } from 'utils/url';
import { useTemporaryStorage } from 'utils/useTemporaryStorage';

type Props = {
  saveListing: typeof saveListingAction;
  saveSearch: typeof saveSearchAction;
  subscribeToSubsite: typeof subscribeToSubsiteAction;
};
type TemporaryStorageType = {
  redirectUrl?: string;
  listing?: {
    id: string;
    type: string;
    name: string;
  };
  subscribedSubsiteId?: string;
  savedSearch: SavedSearchUnsaved;
};

function UnconnectedTemporaryStorageHandler({
  saveListing,
  saveSearch,
  subscribeToSubsite,
}: Props) {
  const history = useHistory();
  const tmpId =
    typeof window !== 'undefined'
      ? getFirstParam(window.location, 'tmpId')
      : '';
  const [, temporaryStorage] = useTemporaryStorage<TemporaryStorageType>(tmpId);
  useEffect(() => {
    if (temporaryStorage) {
      if (
        'redirectUrl' in temporaryStorage &&
        typeof temporaryStorage.redirectUrl === 'string'
      ) {
        if (isExternalURL(temporaryStorage.redirectUrl)) {
          window.location.href = temporaryStorage.redirectUrl;
        } else {
          history.replace(getRelativeURL(temporaryStorage.redirectUrl));
        }
      }

      if (
        'listing' in temporaryStorage &&
        temporaryStorage.listing.id &&
        temporaryStorage.listing.type &&
        temporaryStorage.listing.name
      ) {
        saveListing(
          temporaryStorage.listing.id,
          temporaryStorage.listing.type,
          temporaryStorage.listing.name
        );
      }

      if ('subscribedSubsiteId' in temporaryStorage) {
        subscribeToSubsite(temporaryStorage.subscribedSubsiteId);
      }

      if ('savedSearch' in temporaryStorage) {
        saveSearch(temporaryStorage.savedSearch);
      }
    }
  }, [
    history,
    saveListing,
    saveSearch,
    subscribeToSubsite,
    temporaryStorage,
    tmpId,
  ]);
  return null;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  saveListing: (listingId, listingType, listingName) =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch<any>(saveListingAction(listingId, listingType, listingName)),
  subscribeToSubsite: (subsiteId) =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch<any>(subscribeToSubsiteAction(subsiteId)),
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saveSearch: (search) => dispatch<any>(saveSearchAction(search)),
});

export const TemporaryStorageHandler = connect(
  null,
  mapDispatchToProps
)(UnconnectedTemporaryStorageHandler);
